<template>
  <div>
    <table-component
      ref="table"
      :table-div-id="tableDivId"
      :show-filter="false"
      :data="fetchData"
      table-class="table"
    >
      <table-column
        v-if="userType == 'funder'"
        :label="$t('reports.pos.po_date')"
        sort-as="prepayment_date"
      >
        <template slot-scope="row">
          <p>{{ row.pre_payment_request.formattedPrePaymentDate }}</p>
        </template>
      </table-column>
      <table-column
        v-else
        :label="$t('invoices.date')"
        sort-as="invoice_date"
        show="formattedInvoiceDate"
      />
      <table-column
        v-if="userType == 'funder'"
        :label="$t('reports.pos.due_date')"
        sort-as="promised_date"
      >
        <template slot-scope="row">
          <p>
            {{ row.pre_payment_request.invoice.formattedPromisedPaymentDate }}
          </p>
        </template>
      </table-column>
      <table-column
        v-else
        :label="$t('invoices.due_date')"
        sort-as="due_date"
        show="formattedDueDate"
      />
      <table-column
        v-if="
          userType === 'super_admin' ||
            userType === 'supplier' ||
            userType === 'funder'
        "
        :label="$t('invoices.customer')"
        width="20%"
      >
        <template slot-scope="row">
          <p v-if="row.buyer_stakeholder">
            <span
              v-if="
                userType == 'supplier' &&
                  row.customer.parent_account_id &&
                  row.buyer_stakeholder.details.company &&
                  row.buyer_stakeholder.details.company.name
              "
            >
              {{ row.buyer_stakeholder.details.company.name }}
            </span>
            <span
              v-else-if="
                userType == 'supplier' && row.customer.parent_account_id == null
              "
            >
              {{ row.buyer_stakeholder.details.user.name }}
            </span>
            <!-- {{row.buyer_stakeholder.details.user.name}} -->
            <span v-else>
              {{ row.buyer_stakeholder.details.company.name }}
            </span>
          </p>
        </template>
      </table-column>

      <table-column
        v-if="
          userType === 'super_admin' ||
            userType === 'anchor' ||
            userType === 'funder'
        "
        :label="$t('invoices.supplier')"
      >
        <template slot-scope="row">
          <p v-if="row.supplier_stakeholder">
            <span
              v-if="
                row.supplier_stakeholder.details.company &&
                  row.supplier_stakeholder.details.company.name
              "
            >
              {{ row.supplier_stakeholder.details.company.name }}
            </span>
            <!-- {{row.supplier_stakeholder.details.user.name}} -->
          </p>
        </template>
      </table-column>
      <table-column
        v-if="userType != 'super_admin'"
        :label="$t('invoices.status')"
        sort-as="status"
      >
        <template v-if="row.overall_status" slot-scope="row">
          <span> {{ $t("invoices.status") }}</span>
          <span
            v-if="userType == 'anchor' && row.overall_status == 'SENT'"
            :class="'inv-status-' + row.overall_status.toLowerCase()"
            >{{ $t("general.received").toUpperCase() }}</span
          >
          <span
            v-else-if="userType == 'anchor' && row.overall_status != 'SENT'"
            :class="'inv-status-' + row.overall_status.toLowerCase()"
            >{{
              row.overall_status != "PARTIALLY_PAID"
                ? row.overall_status
                : row.overall_status.replace("_", " ")
            }}</span
          >
          <span
            v-else-if="userType != 'anchor'"
            :class="'inv-status-' + row.overall_status.toLowerCase()"
            >{{
              row.overall_status != "PARTIALLY_PAID"
                ? row.overall_status
                : row.overall_status.replace("_", " ")
            }}</span
          >
        </template>
      </table-column>

      <!-- <table-column
          :label="$t('invoices.invoice_number')"
          show="invoice_number"
        /> -->
      <table-column :label="$t('pos.ref_num')" show="reference_number" />
      <table-column :label="$t('invoices.amount')" sort-as="total">
        <template slot-scope="row">
          <span>{{ $t("invoices.amount") }}</span>
          <div
            v-html="
              $utils.formatMoney(row.nominal_amount, row.customer.currency)
            "
          />
        </template>
      </table-column>
      <table-column :label="$t('invoices.prePayment')" sort-as="request_level">
        <template slot-scope="row">
          <span> {{ $t("invoices.prePayment") }}</span>
          <span
            v-if="row.request_level == 'Pending' && row.funder_invoices.user"
            :class="'inv-status-' + row.request_level.toLowerCase()"
          >
            {{ row.request_level }}-{{ row.funder_invoices.user.name }}</span
          >
          <span
            v-else-if="row.request_level == 'Financed'"
            :class="'inv-status-' + row.request_level.toLowerCase()"
            >{{ $t("general.financing_approved") }}</span
          >
          <span v-else :class="'inv-status-' + row.request_level.toLowerCase()">
            {{ row.request_level }}</span
          >
        </template>
      </table-column>
    </table-component>
  </div>
</template>
<script>
export default {
  props: {
    fetchData: { default: () => [], type: [Array, Function, Object] },
    tableDivId: { default: "", type: String }
  },
  data() {
    return {
      userType: ""
    };
  },
  created() {
    if (
      localStorage.getItem("account_type") == "funder" ||
      localStorage.getItem("role") == "super_admin" ||
      localStorage.getItem("account_type") == "anchor"
    ) {
      this.advanceOption = false;
    } else {
      this.advanceOption = true;
    }
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
    } else if (localStorage.getItem("account_type") == "funder") {
      this.userType = "funder";
    }
  },
  methods: {}
};
</script>
<style scoped>
.table-component {
  min-height: 0px !important;
}
</style>
